import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { SegmentOption } from '../../../../components/segmented-control/segmented-control.component';
import { OFFER_STATUSES, OfferStatus, OfferStatusEntry } from '../../../../services/pricing-offer.service';

export interface OfferStatusDialogResult {
  status: OfferStatus;
  reason: string;
}

/** Status eines Angebots setzen (Entwurf · Angebot · Angenommen · Abgelehnt) mit Begründung und Verlauf. */
@Component({
  selector: 'app-offer-status-dialog',
  templateUrl: './offer-status-dialog.component.html',
  styleUrl: './offer-status-dialog.component.scss',
})
export class OfferStatusDialogComponent implements OnInit {
  @Input() name = '';
  @Input() status: OfferStatus = 'draft';
  @Input() reason = '';
  @Input() history: OfferStatusEntry[] = [];

  options: SegmentOption[] = [];
  /** Neueste zuerst. */
  entries: OfferStatusEntry[] = [];

  constructor(
    protected dialogRef: NbDialogRef<OfferStatusDialogComponent>,
    private t: TranslateService,
  ) {}

  ngOnInit(): void {
    this.options = OFFER_STATUSES.map((s) => ({
      value: s,
      label: this.t.instant(`pages.admin.pricing.offers.status.${s}`),
    }));
    this.entries = [...(this.history ?? [])].reverse();
  }

  setStatus(v: string): void {
    this.status = v as OfferStatus;
  }

  tone(s: OfferStatus): string {
    return STATUS_TONE[s];
  }

  save(): void {
    const result: OfferStatusDialogResult = { status: this.status, reason: (this.reason || '').trim() };
    this.dialogRef.close(result);
  }
}

export const STATUS_TONE: Record<OfferStatus, string> = {
  draft: 'neutral',
  offered: 'info',
  accepted: 'accept',
  rejected: 'error',
};
